import React from "react";
import "./BannerAnalyticComponent.css";
import { Apiurl } from "../../Pages/utils/page";
import { Modal } from "react-bootstrap";
import Loader from "../Loader/Loader";
import { ClipLoader } from "react-spinners";

const BannerAnalyticComponent = ({
  bannerAnalyticData,
  handleFilterData,
  setShowUserDataModal,
  setShowUserPotentialDataModal,
  showUserDataModal,
  showUserPotentialData,
  handleProductDataModal,
  showProductDataModal,
  setShowProductModal,
  handleUserDataModal,
  handleUserPotentialDataModal,
  userFilterData,
  ProductsDataFromId,
  productDataById,
  ProductsDataBuyuser,
  productDataBuyUser,
  setShowBuyTable,
  showBuyTable,
  handlepublish,
  loading,
  handleDeleteBanner,
}) => {
  return (
    <div className="banner_section" style={{ flex: "1" }}>
      {loading === "banner" ? (
        <div className="loading-container">
          <Loader />
        </div>
      ) : null}
      <div className="container">
        <div className="banner_analytics_section">
          <div className="row">
            <div className="table-responsive custom-table-01">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Sr.No</th>
                    <th>Banner</th>
                    <th>No. of Views</th>
                    <th>Save For Later Users</th>
                    <th>Publish</th>
                    <th>Product Info</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {bannerAnalyticData?.map((item, index) => {
                    const banner = item?.BannerURL.split('"');
                    const bannerUrl = `${Apiurl()}/${banner?.[1]}`;
                    return (
                      <tr>
                        <td>{index + 1}</td>
                        <td>
                          <img
                            className="banner_image_analytic"
                            src={bannerUrl}
                            alt="Banner Image"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = "/Images/banner-default.jpg";
                            }}
                          />
                        </td>
                        <td>
                          <div className="banner_anay_viwe_center">
                            <span>{item?.TotalViews}</span>
                            <input
                              type="button"
                              value="All Users Data"
                              className="common_btn view-data-btn"
                              onClick={() => {
                                setShowUserDataModal(true);
                                handleFilterData(item, "userData");
                              }}
                            />
                          </div>
                        </td>
                        <td>
                          <div className="banner_anay_viwe_center">
                            <span>{item?.SaveForLaterCount}</span>
                            <input
                              type="button"
                              value="Potential Users Data"
                              className="common_btn view-data-btn"
                              onClick={() => {
                                setShowUserPotentialDataModal(true);
                                handleFilterData(item, "potentialData");
                              }}
                            />
                          </div>
                        </td>
                        <td>
                          <div className="form-check form-switch">
                            <input
                              checked={item?.IsPublish}
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              onChange={() => handlepublish(item)}
                            />
                          </div>
                        </td>
                        <td>
                          <input
                            type="button"
                            value="Products Data"
                            onClick={() => {
                              setShowProductModal(true);
                              ProductsDataFromId(item, "productData");
                            }}
                            className="common_btn view-data-btn"
                          />
                        </td>
                        <td>
                          <button
                            className="common_btn btn_danger_analtic"
                            onClick={() => handleDeleteBanner(item)}
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      {/* user Detail Modal */}
      <Modal
        show={showUserDataModal}
        onHide={handleUserDataModal}
        backdrop="static"
        className="userDetailModal"
      >
        <Modal.Header closeButton>
          <h4
            className="modal-title common_heading"
            id="TotalViewsFormModalLabel"
          >
            All Users Who Viewed This Banner
          </h4>
        </Modal.Header>
        <Modal.Body className="popup_body_scroll">
          <div className="table-responsive custom-table">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Profile</th>
                  <th>Username</th>
                </tr>
              </thead>
              <tbody>
                {userFilterData?.length ? (
                  userFilterData?.map((item) => {
                    return (
                      <tr>
                        <td>
                          <img
                            className="userDataPhoto"
                            src="/Images/unisexImage.jpeg"
                          />
                        </td>

                        <td>{item?.Name}</td>
                      </tr>
                    );
                  })
                ) : (
                  <ClipLoader className="main_loader_home" loading size={15} />
                )}
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>
      {/* user potential Detail Modal */}
      <Modal
        show={showUserPotentialData}
        onHide={handleUserPotentialDataModal}
        backdrop="static"
        className="userDetailModal"
      >
        <Modal.Header closeButton>
          <h4
            className="modal-title common_heading"
            id="TotalViewsFormModalLabel"
          >
            All Users Who Viewed This Banner
          </h4>
        </Modal.Header>
        <Modal.Body className="popup_body_scroll">
          <div className="table-responsive custom-table">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Profile</th>
                  <th>Username</th>
                </tr>
              </thead>
              <tbody>
                {userFilterData?.length ? (
                  userFilterData?.map((item) => {
                    const image = item?.Image?.split('"');
                    const imageUrl = `${Apiurl()}/${image?.[1]}`;
                    return (
                      <tr>
                        <td>
                          <img
                            className="userDataPhoto"
                            src={imageUrl}
                            onError={(e) => {
                              e.target.onerror = null; // Prevent infinite loop
                              e.target.src = "/Images/unisexImage.jpeg";
                            }}
                          />
                        </td>

                        <td>{item?.Name}</td>
                      </tr>
                    );
                  })
                ) : (
                  <ClipLoader className="main_loader_home" loading size={15} />
                )}
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>

      {/* product data Modal */}
      <Modal
        show={showProductDataModal}
        onHide={handleProductDataModal}
        backdrop="static"
        className="userDetailModal"
      >
        <Modal.Header closeButton>
          <h4
            className="modal-title common_heading"
            id="TotalViewsFormModalLabel"
          >
            All Products Related This Banner
          </h4>
          <h6 className="mt-2">
            Total Products :{" "}
            {showBuyTable
              ? productDataBuyUser?.TotalCount
              : productDataById?.TotalProductsCount}
          </h6>
        </Modal.Header>
        <Modal.Body className="popup_body_scroll">
          <div className="table-responsive custom-table">
            <table className="table table-striped">
              {showBuyTable ? (
                <>
                  <button
                    type="button"
                    className="common_btn btn-primary mt-2"
                    onClick={() => setShowBuyTable(false)}
                  >
                    Go Back
                  </button>
                  <thead>
                    <tr>
                      <th>Index</th>
                      <th>Image</th>
                      <th>Username</th>
                      <th>UserEmail</th>
                      <th>Quantity</th>
                    </tr>
                  </thead>
                  {loading === "buyUser" ? (
                    <ClipLoader
                      className="main_loader_home"
                      loading
                      size={15}
                    />
                  ) : (
                    <tbody>
                      {productDataBuyUser?.UserInfo?.map((i, index) => {
                        const banner = i?.ProfileUrl.split('"');
                        const bannerUrl = `${Apiurl()}/${banner?.[1]}`;
                        return (
                          <tr>
                            <td>{index + 1}</td>
                            <td>
                              <img
                                className="productDataModalImage"
                                src={bannerUrl}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src =
                                    "/Images/no-product-img-700.jpg";
                                }}
                              />
                            </td>
                            <td>{i?.UserName}</td>
                            <td>{i?.UserEmail}</td>
                            <td>{i?.Quantity}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  )}
                </>
              ) : (
                <>
                  <thead>
                    <tr>
                      <th>Index</th>
                      <th>ProductId</th>
                      <th>Image</th>
                      <th>ProductName</th>
                      <th>IsPublish</th>
                      <th>Users</th>
                    </tr>
                  </thead>
                  {loading === "productId" ? (
                    <ClipLoader
                      className="main_loader_home"
                      loading
                      size={15}
                    />
                  ) : (
                    <tbody>
                      {productDataById?.Products?.map((i, index) => {
                        const images = JSON.parse(i.Images || "[]");
                        const defaultImage = images?.find(
                          (img) => img.Default === true
                        )?.Images;
                        return (
                          <tr>
                            <td>{index + 1}</td>
                            <td>{i?.Id}</td>
                            <td>
                              <img
                                className="productDataModalImage"
                                src={`${Apiurl()}/${defaultImage}`}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src =
                                    "/Images/no-product-img-700.jpg";
                                }}
                              />
                            </td>
                            <td>{i?.ProductName}</td>
                            <td>{i?.IsPublish}</td>
                            <td className="check_table_btn_width">
                              <button
                                type="button"
                                className="common_btn view-data-btn"
                                onClick={() => {
                                  ProductsDataBuyuser(i, "buyUser");
                                  setShowBuyTable(true);
                                }}
                              >
                                Check Buy Users
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  )}
                </>
              )}
            </table>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default BannerAnalyticComponent;
